<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
import {
  getMeetingData,
} from "./api/home";
export default {
  name: 'App',
  created() {
    this.getMeetingData()
  },
  methods: {
    // 大会详情
    async getMeetingData() {
      const { data } = await getMeetingData();
      localStorage.setItem('meetingData', data.name);
    },
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue